<template>
  <div class="loading-demo">
    <h2>加载动画指令演示</h2>
    
    <div class="demo-section">
      <h3>基础用法</h3>
      <el-button @click="showBasicLoading">显示基础加载</el-button>
      <el-button @click="hideBasicLoading">隐藏基础加载</el-button>
      
      <div v-loading="basicLoadingVisible" loading-text="基础加载中...">
        <div class="demo-content">
          <p>这是一个基础加载示例，点击按钮可以控制加载状态</p>
        </div>
      </div>
    </div>
    
    <div class="demo-section">
      <h3>自定义文本</h3>
      <el-button @click="showCustomLoading">显示自定义文本加载</el-button>
      <el-button @click="hideCustomLoading">隐藏自定义文本加载</el-button>
      
      <div v-loading="customLoadingVisible" loading-text="正在处理数据...">
        <div class="demo-content">
          <p>这个示例展示了如何自定义加载文本</p>
        </div>
      </div>
    </div>
    
    <div class="demo-section">
      <h3>状态管理控制</h3>
      <el-button @click="showStoreLoading">显示状态管理加载</el-button>
      <el-button @click="hideStoreLoading">隐藏状态管理加载</el-button>
      
      <div v-loading="$store.getters.loadingVisible" 
           :loading-text="$store.getters.loadingText">
        <div class="demo-content">
          <p>这个示例通过 Vuex 状态管理来控制加载状态</p>
          <p>当前加载文本: {{ $store.getters.loadingText }}</p>
        </div>
      </div>
    </div>
    
    <div class="demo-section">
      <h3>模拟异步操作</h3>
      <el-button @click="simulateAsyncOperation">模拟异步操作</el-button>
      
      <div v-loading="asyncLoadingVisible" loading-text="正在执行异步操作...">
        <div class="demo-content">
          <p>这个示例模拟了一个异步操作，3秒后自动完成</p>
          <p v-if="asyncResult">操作结果: {{ asyncResult }}</p>
        </div>
      </div>
    </div>
    
    <div class="demo-section">
      <h3>全局加载状态</h3>
      <el-button @click="showGlobalLoading">显示全局加载</el-button>
      <el-button @click="hideGlobalLoading">隐藏全局加载</el-button>
      
      <div class="demo-content">
        <p>全局加载状态会覆盖整个页面</p>
        <p>当前状态: {{ $store.getters.loadingVisible ? '显示中' : '隐藏' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingDemo',
  data() {
    return {
      basicLoadingVisible: false,
      customLoadingVisible: false,
      asyncLoadingVisible: false,
      asyncResult: ''
    }
  },
  methods: {
    // 基础加载控制
    showBasicLoading() {
      this.basicLoadingVisible = true
    },
    hideBasicLoading() {
      this.basicLoadingVisible = false
    },
    
    // 自定义文本加载控制
    showCustomLoading() {
      this.customLoadingVisible = true
    },
    hideCustomLoading() {
      this.customLoadingVisible = false
    },
    
    // 状态管理加载控制
    showStoreLoading() {
      this.$store.commit('showLoading', { 
        text: '状态管理加载中...',
        subText: '这是副文本'
      })
    },
    hideStoreLoading() {
      this.$store.commit('hideLoading')
    },
    
    // 模拟异步操作
    simulateAsyncOperation() {
      this.asyncLoadingVisible = true
      this.asyncResult = ''
      
      setTimeout(() => {
        this.asyncLoadingVisible = false
        this.asyncResult = '异步操作完成！'
      }, 3000)
    },
    
    // 全局加载控制
    showGlobalLoading() {
      this.$store.commit('showLoading', { 
        text: '全局加载中...',
        subText: '请稍候...'
      })
    },
    hideGlobalLoading() {
      this.$store.commit('hideLoading')
    }
  }
}
</script>

<style scoped>
.loading-demo {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.demo-section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.demo-section h3 {
  margin-top: 0;
  color: #303133;
}

.demo-content {
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-top: 15px;
  min-height: 100px;
}

.el-button {
  margin-right: 10px;
  margin-bottom: 10px;
}

h2 {
  text-align: center;
  color: #303133;
  margin-bottom: 30px;
}
</style>